import { render, staticRenderFns } from "./SettingsPassword.vue?vue&type=template&id=03db1b5c&scoped=true"
import script from "./SettingsPassword.vue?vue&type=script&lang=js"
export * from "./SettingsPassword.vue?vue&type=script&lang=js"
import style0 from "./SettingsPassword.vue?vue&type=style&index=0&id=03db1b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db1b5c",
  null
  
)

export default component.exports